import { useEffect, useState } from "react";
import {
  Droppable as ReactBeautifulDndDroppable,
  DroppableProps,
} from "@hello-pangea/dnd";

const Droppable = ({ children, ...props }: DroppableProps) => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const animation = requestAnimationFrame(() => setEnabled(true));

    return () => {
      cancelAnimationFrame(animation);
      setEnabled(false);
    };
  }, []);

  if (!enabled) {
    return null;
  }

  return (
    <ReactBeautifulDndDroppable {...props}>
      {children}
    </ReactBeautifulDndDroppable>
  );
};

export default Droppable;
